/**
 * The version this build reports — in the sidebar, and as the second half of
 * the Sentry release that source maps are uploaded under.
 *
 * It used to be `require('../../../package.json').version`. Webpack cannot
 * tree-shake a CommonJS require of a JSON file, so it inlined the whole
 * manifest into the entry chunk every merchant fetches on first load:
 * `e.exports=JSON.parse('{"name":"tymber-mission-control",…')`, dependency
 * list, `scripts` block, Jest thresholds and all — 6,758 bytes of the entry
 * chunk for one string, listed as candidate 9 of ECOM-3375's baseline.
 * Removing it took that chunk from 346,288 to 339,598 bytes raw and from
 * 101,285 to 98,586 gzipped. Two consequences, and the second kept biting:
 * the repository's build configuration was disclosed to every browser, and
 * **editing an npm script moved the production bundle size**, so a CI-tooling
 * change registered as an application performance regression.
 *
 * `craco.config.js` now sets `REACT_APP_VERSION` from `package.json` before
 * react-scripts reads the environment, and CRA's DefinePlugin inlines it as
 * the literal string. One source either way — `scripts/build-version.cjs
 * --write` derives that field from git at the start of `yarn build`, before
 * craco loads, and `scripts/sentry-release.cjs` reads it back afterwards, so
 * the release name cannot drift from what source maps are uploaded under. The
 * number is CalVer — `2026.11.02.1` on `master`, where the date is the UTC
 * day the commit landed and the digit is its position among that day's
 * merges;
 * `2026.11.02.1-rc` on `develop`; and `2026.11.02-ecom-3449-sidebar.ba1f6a4` on
 * any branch this repository does not deploy — and it is never committed.
 * See ECOM-3397, docs/adrs/0019-calver-build-version.md and
 * docs/adrs/0018-build-version-derived-from-git.md, which it amends.
 *
 * Read as a literal `process.env.REACT_APP_VERSION` member access on purpose:
 * that is the form CRA inlines. Anything else compiles to undefined. There is
 * deliberately no fallback — a build that somehow bypassed craco should say
 * `undefined` loudly rather than report a plausible version that is wrong.
 */
export function getVersion() {
  return process.env.REACT_APP_VERSION;
}
